import RolesFilterContainer from './roles_filter_container';

const RolesFilter = RolesFilterContainer;
export default RolesFilter;
